<div class="lotam-details" [ngClass]="{'lotam-blocked': status === MissionNoticeDto.Status.BLOCK}">
    <div class="result-container">
        <div class="lotam-selector">
            <div class="vertical-container fill">
                <div class="fill">
                    <strong>
                        {{ lotam.subject }}
                    </strong>
                </div>
                <div class="horizontal-container wrap fill parameter-summary">
                    <div>
                        {{
                            lotam.startTime
                                | formatDateRange
                                    : lotam.endTime
                                    : organisation.timeZone
                        }}
                    </div>
                    <div>
                        {{ lotam.lowerLimit | formatAltitudeValue: 'SFC' }} -
                        {{
                            lotam.upperLimit | formatAltitudeValue: 'Unlimited'
                        }}
                    </div>
                </div>
            </div>
            <div
                class="horizontal-container vertical-align lotam-actions-container"
            >
                <button
                    *ngIf="!isExpanded"
                    type="button"
                    (click)="isExpanded = !isExpanded"
                    class="btn btn-tertiary"
                >
                    <span class="fa fa-chevron-down"></span>
                </button>
                <button
                    *ngIf="isExpanded"
                    type="button"
                    (click)="isExpanded = !isExpanded"
                    class="btn btn-tertiary"
                >
                    <span class="fa fa-chevron-up"></span>
                </button>
                <div style="width: 24px; flex-shrink: 0;">
                    <field-validation-indicator
                        *ngIf="!isReadOnly && status === 'APPLICABLE'"
                        [valid]="isAcknowledged"
                        [customTooltip]="
                            isAcknowledged
                                ? 'You have acknowledged this LOTAM'
                                : 'You have not acknowledged this LOTAM'
                        "
                    ></field-validation-indicator>
                </div>
                <button
                    type="button"
                    class="btn btn-xs btn-pill btn-primary left-buffer"
                    tooltip="View and acknowledge LOTAM"
                    placement="top"
                    (click)="viewLotamDetail()"
                >
                    {{ buttonText }}
                </button>
                <div
                    style="line-height: 37px"
                    class="no-wrap"
                    *ngIf="locationBearing != null"
                >
                    <span [innerHtml]="locationBearing | bearing"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="contents top-buffer" @collapse *ngIf="isExpanded">
        <ng-container *ngIf="lotam.noticeType">
            <span class="display-label top-buffer">LOTAM Type</span>
            <div>
                {{ lotam.noticeType?.name }}
            </div>
        </ng-container>
        <span class="display-label">Contact Name</span>
        <div>
            {{ lotam.pointOfContact ? lotam.pointOfContact : '-' }}
        </div>
        <span class="display-label">Contact Phone</span>
        <div>
            {{
                lotam.pointOfContactPhoneNumber
                    ? lotam.pointOfContactPhoneNumber
                    : '-'
            }}
        </div>
        <span class="display-label top-buffer">Description</span>
        <div class="pre-line">
            {{ lotam.description ? lotam.description : '-' }}
        </div>
    </div>
</div>
